module.exports = "/img/commercial_vehicle.bbf980c1.png";